import React from 'react';
import verificationpic from "../../../../assets/images/thanks.png";
import Button from '../../Button/Button';
import Modal from '../Modal/Modal';
import styles from "./ThanksModal.module.scss";
import { KycApproveIcon } from '../../../../assets/icons/svgicons';

const ThanksModal = ({ show, handleClose }) => {
  return (
    <Modal className={styles.thanks_modal}
      show={show}
      handleClose={handleClose}
      title={true}>
      <div className={styles.direct_sec}>
        <div className={styles.deposit_img}>
          <KycApproveIcon />
        </div>
        <h2 className="smallText">Thank you</h2>
        <p>We received your document. Please give us 3-5 business days to verify it. As soon as we complete our review, we’ll send you an email.</p>
      </div>
      <Button
        fluid
        variant="secondary_btn"
        onClick={handleClose}
        className={styles.submit_btn}
      >Done</Button>
    </Modal>
  )
}

export default ThanksModal